import React, { useState, useEffect } from "react";
import {
  Col, Modal, ModalBody, ModalFooter, ModalHeader,
  Label, Input, Row
} from "reactstrap";

import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import StatusBadge from "../../components/StatusBadge";

import {
  createSpecType,
  getSpecTypeById,
  updateSpecType,
  deleteSpecType,
  listSpecTypeByParams,
  familyDropdown
} from "../../api/specType.api";

const initialState = {
  family_id: "",
  spec_label: "",
  sequence: "",
  is_active: true
};

const SpecTypeMaster = () => {

  const [values, setValues] = useState(initialState);
  const [data, setData] = useState([]);
  const [families, setFamilies] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState(true);

  const [_id, set_Id] = useState("");
  const [remove_id, setRemove_id] = useState("");

  const [modal_add, setModalAdd] = useState(false);
  const [modal_edit, setModalEdit] = useState(false);
  const [modal_delete, setModalDelete] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [totalRows, setTotalRows] = useState(0);



  const fetchFamilies = async () => {
    const res = await familyDropdown();
    setFamilies(res.data.data || []);
  };



  const fetchData = async () => {

    setLoading(true);

    const skip = (pageNo - 1) * perPage;

    const res = await listSpecTypeByParams({
      skip,
      per_page: perPage,
      match: query,
      is_active: filter
    });

    if (res.data.data.length > 0) {

      const result = res.data.data[0];

      setData(result.data);
      setTotalRows(result.count);

    } else {
      setData([]);
    }

    setLoading(false);

  };



  useEffect(() => {
    fetchFamilies();
    fetchData();
  }, [query, filter, pageNo, perPage]);



  const handleChange = (e) =>
    setValues({ ...values, [e.target.name]: e.target.value });

  const handleCheck = (e) =>
    setValues({ ...values, [e.target.name]: e.target.checked });



  const handleCreate = (e) => {

    e.preventDefault();

    setIsLoading(true);

    createSpecType(values)
      .then(() => {

        toast.success("Spec Type Added");

        setModalAdd(false);
        setValues(initialState);

        fetchData();

      })
      .finally(() => setIsLoading(false));

  };



  const handleEdit = (id) => {

    set_Id(id);

    getSpecTypeById(id).then(res => {

      setValues(res.data.data);
      setModalEdit(true);

    });

  };



  const handleUpdate = (e) => {

    e.preventDefault();

    updateSpecType(_id, values).then(() => {

      toast.success("Updated");

      setModalEdit(false);
      setValues(initialState);

      fetchData();

    });

  };



  const handleDelete = () => {

    setIsDeleteLoading(true);

    deleteSpecType(remove_id)
      .then(() => {

        toast.success("Deleted");

        setModalDelete(false);

        fetchData();

      })
      .finally(() => setIsDeleteLoading(false));

  };



  const customStyles = {
    headRow: { style: { borderBottom: "2px solid #f3f4f6" } },
    headCells: {
      style: {
        color: "#6b7280",
        fontWeight: "700",
        textTransform: "uppercase",
        fontSize: "11px",
        letterSpacing: "0.5px"
      }
    },
    cells: { style: { fontSize: "14px", color: "#374151", padding: "15px 10px" } },
  };



  const columns = [

    { name: "Sr No", selector: (r, i) => i + 1, width: "70px" },

    { name: "Specification", selector: r => r.spec_label, grow: 2, style: { fontWeight: "600" } },

    { name: "Family", selector: r => r.family_name },

    { name: "Sequence", selector: r => r.sequence,  center: true },

    {
      name: "Status",
      center: true,
      cell: (r) => (
        <StatusBadge status={r.is_active ? "ACTIVE" : "INACTIVE"} />
      )
    },

    {
      name: "Actions",
      right: true,
      cell: (row) => (
        <div className="d-flex gap-3">

          <button
            className="btn btn-link p-0 text-muted"
            onClick={() => handleEdit(row.id)}
          >
            🖊️
          </button>

          <button
            className="btn btn-link p-0 text-danger"
            onClick={() => {
              setRemove_id(row.id);
              setModalDelete(true);
            }}
          >
            🗑️
          </button>

        </div>
      )
    }

  ];



  return (

    <div style={{ backgroundColor: "#ffffff", padding:"clamp(15px, 3vw, 24px)",borderRadius:"12px",border:"1px solid #e5e7eb" }}>

      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">

        <div>
          <h4 className="fw-bold m-0" style={{ color: "#112347" }}>Specification Type Master</h4>
          <p className="text-muted small m-0">Define technical attribute categories for products</p>
        </div>

        <button
          className="btn btn-dark fw-bold px-4 py-2"
          style={{ backgroundColor: "#112347", borderRadius: "8px", border: "none" }}
          onClick={() => {
            setValues(initialState);
            setModalAdd(true);
          }}
        >
          + Add Specification
        </button>

      </div>



      <Row className="mb-4 g-2 g-md-3">

        <Col xs="12" md="5" className="position-relative">

          <span className="position-absolute translate-middle-y top-50 ms-3 text-muted">🔍</span>

          <Input
            placeholder="Search Specifications..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            style={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", paddingLeft: "40px" }}
          />

        </Col>

        <Col xs="12" md="4">

          <div className="h-100 d-flex align-items-center border rounded px-3 py-2 py-md-0"
            style={{ backgroundColor: "#f9fafb", borderColor: "#e5e7eb" }}>

            <Input
              type="checkbox"
              checked={filter}
              onChange={(e) => setFilter(e.target.checked)}
            />

            <Label className="ms-2 mb-0 small fw-bold text-muted">
              Active Only
            </Label>

          </div>

        </Col>

      </Row>



      <div className="table-responsive border rounded-3 overflow-hidden">

        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={setPageNo}
          onChangeRowsPerPage={setPerPage}
          customStyles={customStyles}
        />

      </div>



      {/* ADD MODAL */}

      <Modal isOpen={modal_add} toggle={() => setModalAdd(false)} centered>

        <ModalHeader className="border-0 pb-0">Add Spec Type</ModalHeader>

        <ModalBody className="pt-2">

          <Label className="small fw-bold">Family</Label>

          <Input
            type="select"
            name="family_id"
            value={values.family_id}
            onChange={handleChange}
            className="mb-3"
          >
            <option value="">Select</option>
            {families.map(f => (
              <option key={f.id} value={f.id}>
                {f.family_name}
              </option>
            ))}
          </Input>

          <Label className="small fw-bold">Specification Label</Label>

          <Input
            name="spec_label"
            value={values.spec_label}
            onChange={handleChange}
            className="mb-3"
          />

          <Label className="small fw-bold">Sequence</Label>

          <Input
            type="number"
            name="sequence"
            value={values.sequence}
            onChange={handleChange}
          />

          <div className="mt-3 d-flex align-items-center">

            <Input
              type="checkbox"
              name="is_active"
              checked={values.is_active}
              onChange={handleCheck}
            />

            <Label className="ms-2 mb-0">Is Active</Label>

          </div>

        </ModalBody>

        <ModalFooter className="border-0">

          <button
            className="btn btn-dark w-100 py-2 fw-bold"
            onClick={handleCreate}
            disabled={isLoading}
            style={{ backgroundColor: "#112347" }}
          >
            Save Specification
          </button>

        </ModalFooter>

      </Modal>



      {/* EDIT MODAL */}

      <Modal isOpen={modal_edit} toggle={() => setModalEdit(false)} centered>

        <ModalHeader>Edit Spec Type</ModalHeader>

        <ModalBody>

          <Label>Family</Label>

          <Input
            type="select"
            name="family_id"
            value={values.family_id}
            onChange={handleChange}
          >
            <option value="">Select</option>
            {families.map(f => (
              <option key={f.id} value={f.id}>{f.family_name}</option>
            ))}
          </Input>

          <Label className="mt-2">Specification Label</Label>

          <Input
            name="spec_label"
            value={values.spec_label}
            onChange={handleChange}
          />

          <Label className="mt-2">Sequence</Label>

          <Input
            type="number"
            name="sequence"
            value={values.sequence}
            onChange={handleChange}
          />

          <div className="mt-3">

            <Input
              type="checkbox"
              name="is_active"
              checked={values.is_active}
              onChange={handleCheck}
            />

            <Label className="ms-2">Is Active</Label>

          </div>

        </ModalBody>

        <ModalFooter>

          <button
            className="btn btn-success w-100"
            onClick={handleUpdate}
          >
            Update
          </button>

        </ModalFooter>

      </Modal>



      {/* DELETE MODAL */}

      <Modal isOpen={modal_delete} toggle={() => setModalDelete(false)} centered>

        <ModalBody className="text-center py-4">

          <h5 className="fw-bold">Confirm Delete</h5>

          <p className="text-muted">
            Delete this specification type permanently?
          </p>

          <div className="d-flex gap-2 justify-content-center mt-4">

            <button
              className="btn btn-light px-4"
              onClick={() => setModalDelete(false)}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger px-4"
              onClick={handleDelete}
              disabled={isDeleteLoading}
            >
              Delete
            </button>

          </div>

        </ModalBody>

      </Modal>

    </div>

  );

};

export default SpecTypeMaster;